import Immutable from 'seamless-immutable';

import {
    INVITE_ITEM_REQUEST,
    INVITE_ITEM_SUCCESS,
    INVITE_ITEM_ERROR,

    INVITE_UPDATE_REQUEST,
    INVITE_UPDATE_ERROR,
    INVITE_UPD_ITEM_SUCCESS,
    INVITE_UPD_ITEM_ERROR,
    INVITES_SEND_REQUEST,
    INVITES_SEND_ERROR,

    INVITE_VERIFY_REQUEST,
    INVITE_VERIFY_SUCCESS,
    INVITE_VERIFY_ERROR,
    INVITE_UPD_ITEM,

    SET_PREVIEW_MODE,
} from 'Actions/invite';
import {
    DOCUMENT_ITEM_ERROR,
    DOCUMENT_ITEM_REQUEST,
    DOCUMENT_ITEM_SUCCESS,
} from 'Actions/document';
import {
    RSVP_PROCESS_COMPANIONS,
    RSVP_PROCESS_DOCUMENTS,
    STATUS_PENDING,
} from 'Constants';
import { decryptInvite } from 'Utils';

const INITIAL_STATE = Immutable({
    authorized: true,
    data: {},
    failed: false,
    loaded: false,
    loading: false,
    preview: false,
});

export default function inviteItem (state = INITIAL_STATE, action) {
    switch (action.type) {
        case INVITE_ITEM_REQUEST:
            return state.merge({
                loaded: false,
                loading: true,
            });

        // This should be loaded only once
        case INVITE_ITEM_SUCCESS: {
            const data = decryptInvite(action.data);
            let authorized = true;

            if (
                !state.preview &&
                data.rsvp === STATUS_PENDING && data.settings?.secure &&
                (data.settings.secure.password || data.settings.secure.email) &&
                ![
                    RSVP_PROCESS_COMPANIONS,
                    RSVP_PROCESS_DOCUMENTS,
                ].includes(data.rsvpProcess)
            ) {
                authorized = false;
            }
            if (data.inviteHash) {
                data.settings.fields.personal.email = {
                    ...(data.settings.fields.personal.email || {}),
                    disabled: true,
                };
            }

            return state.merge({
                authorized,
                data: data,
                failed: Boolean(data.error),
                loaded: true,
                loading: false,
            });
        }

        case INVITE_ITEM_ERROR:
            return state.merge({
                data: state.data.merge({
                    error: action.error,
                }),
                failed: true,
                loaded: true,
                loading: false,
            });

        case INVITE_UPD_ITEM: {
            return state.merge({
                data: state.data.merge(action.data),
            });
        }

        case INVITE_UPD_ITEM_SUCCESS: {
            const data = decryptInvite(action.data);

            return state.merge({
                data: state.data.merge(data),
                loading: false,
            });
        }

        case INVITE_UPDATE_REQUEST:
        case INVITE_VERIFY_REQUEST:
        case INVITES_SEND_REQUEST:
        case DOCUMENT_ITEM_REQUEST:
            return state.merge({
                loading: true,
            });

        case INVITE_VERIFY_SUCCESS: {
            let data = state.data;

            if (action.data.email) {
                data =
                    data.setIn([
                        'guestInfo',
                        'email',
                        'primary',
                    ], action.data.email);
                data =
                    data.setIn([
                        'settings',
                        'fields',
                        'personal',
                        'email',
                        'disabled',
                    ], true);
            }

            return state.merge({
                authorized: true,
                data,
                loading: false,
            });
        }

        case INVITE_UPDATE_ERROR:
        case INVITE_UPD_ITEM_ERROR:
        case INVITE_VERIFY_ERROR:
        case INVITES_SEND_ERROR:
        case DOCUMENT_ITEM_SUCCESS:
        case DOCUMENT_ITEM_ERROR:
            return state.merge({
                loading: false,
            });

        case SET_PREVIEW_MODE:
            return state.merge({
                authorized: true,
                preview: action.preview,
            });

        default:
            return state;
    }
}
